import { Component, OnInit } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';

import { SnFormFieldConfig } from '@lib/form';
import { t } from '@lib/translation';

@Component({
  selector: 'fs-add-reason-option-dialog',
  templateUrl: './add-reason-option-dialog.component.html',
  styleUrls: ['./add-reason-option-dialog.component.scss'],
})
export class AddReasonOptionDialogComponent implements OnInit {
  public form = new UntypedFormGroup({});
  public formFields: SnFormFieldConfig[] = [
    {
      key: 'reasonOptions',
      type: 'repeat',
      templateOptions: {
        addText: t('form.addReasonOptions'),
      },
      fieldArray: {
        fieldGroupClassName: 'reason-row',
        fieldGroup: [
          {
            key: 'option',
            type: 'input',
            className: 'reason-col',
            templateOptions: {
              label: t('form.option'),
              placeholder: t('form.enterOption'),
              required: true,
            },
          },
        ],
      },
    },
  ];
  public formModel: any = {};

  constructor(private readonly _dialogRef: MatDialogRef<AddReasonOptionDialogComponent>) {
    this.formModel.reasonOptions = [{}];
  }

  public ngOnInit(): void {}

  public submitForm(): void {
    this._dialogRef.close(this.formModel);
  }
}
